import {
  getModule,
  ModuleId,
  TModuleParams,
  getCurrentInstance,
  appDefIds,
} from '@wix/business-manager-api';

export abstract class BaseApiService {
  constructor(public readonly baseUrl: string) {}
  protected get moduleParams(): TModuleParams {
    const moduleParams: TModuleParams = (getModule(ModuleId.Contacts) as any)
      .moduleParams;
    return moduleParams;
  }

  protected get instance(): string {
    const instance = getCurrentInstance(appDefIds.metaSite);
    return instance;
  }

  get msid(): string {
    return this.moduleParams.metaSiteId;
  }

  get locale(): string {
    return this.moduleParams.accountLanguage;
  }
}
